import React from 'react';

const SERVICES = ['GST Registration', 'Company Registration', 'Startup India', 'MSME', 'ISO', 'Trademark', 'FSSAI', 'IEC', 'Business Loan', 'GST Return', 'Income Tax', 'ROC Compliance', 'Import Export', 'APEDA', 'BIS', 'LMPC'];

export const ServicesMarquee = () => (
  <div className="bg-gradient-to-r from-[#0A2463] to-[#123a8f] border-b border-white/10 overflow-hidden py-2.5 group" data-testid="services-marquee">
    <style>{`
      @keyframes uu-marquee { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }
      .uu-marquee-track { animation: uu-marquee 40s linear infinite; }
      .group:hover .uu-marquee-track { animation-play-state: paused; }
    `}</style>
    <div className="flex whitespace-nowrap uu-marquee-track w-max">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center">
          {SERVICES.map((s, i) => (
            <span key={`${dup}-${i}`} className="flex items-center text-sm font-semibold text-white/90 hover:text-[#FFB703] transition-colors cursor-default">
              <span className="px-4">{s}</span>
              <span className="text-[#FFB703]">•</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default ServicesMarquee;
